import { render } from "./CaptainAlerts.vue?vue&type=template&id=1e534ee7"
import script from "./CaptainAlerts.vue?vue&type=script&lang=js"
export * from "./CaptainAlerts.vue?vue&type=script&lang=js"
script.render = render

export default script